import { Trans } from '@lingui/react/macro';
import { Menu } from '@pocketlaw/tetris';
export function NoColumns() {
    return (<Menu.Item disabled>
      <Trans comment="Sortable columns menu: No columns message">No columns</Trans>
    </Menu.Item>);
}
